import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { Box, Grid } from '@mui/material';
import { InputText } from '@/components/shared/InputText';
import { PrimaryButtonStyle, SecondaryButtonStyle } from '../IntegrationDialog';
import { useAppDispatch } from '@/lib/hooks';
import { setLoader } from '@/lib/slices/globalLoaderSlice';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import { DatevLodasSetupRequest } from '@/models/payment';

interface DatevLodasConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const DatevLodasConnect = (props: DatevLodasConnectProps) => {
    const { t } = useTranslation();
    const [datevLodasData, setDatevLodasData] =
        useState<DatevLodasSetupRequest>({});
    const { setAlert } = useNotificationsSnackbar();

    const { setupDatevLodas } = usePaymentsMutations();

    const dispatch = useAppDispatch();

    const onClick = () => {
        setupDatevLodas.mutate({
            instaPaidServiceFeeCode: datevLodasData?.instaPaidServiceFeeCode,
            instaPaidSalaryRecordCode:
                datevLodasData?.instaPaidSalaryRecordCode,
            instaPaidTipsRecordCode: datevLodasData?.instaPaidTipsRecordCode
        });
    };

    useEffect(() => {
        if (setupDatevLodas.isSuccess) {
            props.onSaveSuccess();
        }
    }, [setupDatevLodas.isSuccess]);

    useEffect(() => {
        if (setupDatevLodas.isError) {
            setAlert('Connection failed', 'error');
        }
    }, [setupDatevLodas.isError]);

    useEffect(() => {
        dispatch(setLoader(setupDatevLodas.isPending));
    }, [setupDatevLodas.isPending]);

    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={datevLodasData?.instaPaidServiceFeeCode}
                    label={t('instapaid_service_fee_code')}
                    placeholder={t('')}
                    onChange={(val: any) => {
                        setDatevLodasData({
                            ...datevLodasData,
                            instaPaidServiceFeeCode: val.target.value
                        });
                    }}
                    spacing="10px 0"
                />

                <InputText
                    value={datevLodasData?.instaPaidSalaryRecordCode}
                    label={t('instapaid_salary_record_code')}
                    placeholder={t('')}
                    onChange={(val: any) => {
                        setDatevLodasData({
                            ...datevLodasData,
                            instaPaidSalaryRecordCode: val.target.value
                        });
                    }}
                    spacing="10px 0"
                />

                <InputText
                    value={datevLodasData?.instaPaidTipsRecordCode}
                    label={t('instapaid_tips_record_code')}
                    placeholder={t('')}
                    onChange={(val: any) => {
                        setDatevLodasData({
                            ...datevLodasData,
                            instaPaidTipsRecordCode: val.target.value
                        });
                    }}
                    spacing="10px 0"
                />
            </Box>

            <Grid m={'20px 0'} container justifyContent={'space-around'}>
                <SecondaryButtonStyle
                    onClick={() => {
                        props.onClose?.();
                    }}
                    sx={{ width: '170px' }}
                >
                    {t('cancel')}
                </SecondaryButtonStyle>

                <PrimaryButtonStyle
                    onClick={onClick}
                    sx={{ width: '170px' }}
                    loading={setupDatevLodas.isPending}
                    disabled={!datevLodasData.instaPaidSalaryRecordCode}
                >
                    {t('connect')}
                </PrimaryButtonStyle>
            </Grid>
        </>
    );
};
